<template>
    <md-card-content>
        <md-tabs @md-changed="changeTab" md-active-tab="tab-with-contracts">
            <template slot="md-tab" slot-scope="{ tab }">
                <div class="flex justify-center items-center"
                     @mousedown="goToRoute($event, 'Site Details', { id: site.client_id, idSite: site.id })">
                    {{ tab.label }}
                </div>
            </template>
            <md-tab v-for="tab in tabs" :key="tab.id" :id="tab.id" :md-label="tab.tabTitle">
                <contract-tab :type="tab.type" :active="tab.active" :site="site" :showInfo="false"></contract-tab>
            </md-tab>
        </md-tabs>
    </md-card-content>
</template>

<script>
import ContractTab from "@/pages/Clients/Sites-Contracts/components/ContractTab";
import routerMixin from '@/mixins/router-mixin';

export default {
    name: "Contracts",
    components: {
        ContractTab
    },
    mixins: [routerMixin],
    props: {
        site: Object
    },
    data() {
        return {
            tabs: [
                {
                    id: 'tab-with-contracts', title: 'Contrats en cours', type: 'with-contracts',
                    tabTitle: 'Contrats en cours', active: true
                },
                {
                    id: 'tab-completed-contracts', title: 'Contrats terminés', type: 'completed-contracts',
                    tabTitle: 'Contrats terminés', active: false
                }
            ],
        }
    },
    methods: {
        changeTab(id = 'tab-with-contracts') {
            this.tabs.map(tab => tab.active = false)
            let activeTab = this.tabs.find(tab => tab.id === id)
            if (activeTab) activeTab.active = true
        },
        async getCopiedContract() {
            const { data } = await this.$store.dispatch('contracts/getCopiedContract')
	        const payload = data.id ? {
		        id: data.id,
		        number: data.number,
		        siteId: data.site_id,
		        isCanceled: data.is_canceled,
	        } : null

            await this.$store.dispatch('contracts/storeCopiedContract', payload)
        }
    },
    mounted() {
        this.getCopiedContract()
    }
}
</script>

<style scoped lang="scss">
::v-deep {
    .md-tabs {
        .md-tabs-navigation {
            margin: 10px 0;
            background: #fff !important;
            padding: 0;
            transition: all 150ms ease-in;
            -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
            box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);

            .md-tab-nav-button {
                background: transparent !important;
                color: rgba(0, 0, 0, 0.87) !important;
                min-width: max-content;
                width: 100%;

                :hover {
                    background: rgba(200, 200, 200, 0.2) !important;
                }

                .md-ripple {
                    padding: 0 !important;

                    .md-button-content {
                        height: 100%;
                        width: 100%;

                        &:hover {
                            background: unset !important;
                        }

                        & div {
                            height: 100%;
                            width: 100%;
                        }
                    }
                }

                &.md-active {
                    border-bottom: 2px solid #dd4b39 !important;
                }
            }
        }

        .md-content {
            background: transparent !important;

            table {
                thead {
                    display: contents;
                }
            }

            .md-tab {
                padding: 0;
            }
        }
    }
}
</style>
